module.exports = __webpack_public_path__ + "img/Frame-86.c36748ee.svg";